import { color } from "csx";
import { style, stylesheet } from "typestyle";
export function createTheme(options) {
    const { colorBackground, colorForeground, colorPrimary, colorChoice, colorSeparator, colorInputBackground, colorBackgroundMoreContrast, colorForegroundMoreContrast, colorBackgroundLessContrast, colorForegroundLessContrast, colorError, colorWarning, colorSuccess, } = options;
    const dark = color(colorBackground).lightness() < 0.5;
    return style({
        "--color-background": colorBackground,
        "--color-foreground": colorForeground,
        "--color-primary": colorPrimary,
        "--color-choice": colorChoice || color(colorPrimary).invert().toHexString(),
        "--color-separator": colorSeparator || color(colorForeground).fade(0.5).toHexString(),
        "--color-input-background": colorInputBackground || colorBackground,
        "--color-neutral": "#737373",
        "--color-disabled": "#B0B0B0",
        "--color-background-more-contrast": colorBackgroundMoreContrast || dark ? darker(colorBackground) : lighter(colorBackground),
        "--color-foreground-more-contrast": colorForegroundMoreContrast || dark ? lighter(colorForeground) : darker(colorForeground),
        "--color-background-less-contrast": colorBackgroundLessContrast || dark ? lighter(colorBackground) : darker(colorBackground),
        "--color-foreground-less-contrast": colorForegroundLessContrast || dark ? darker(colorForeground) : lighter(colorForeground),
        "--color-error": colorError || "#a12e30",
        "--color-error-background": "#ffcec2",
        "--color-warning": colorWarning || "#bfa436",
        "--color-success": colorSuccess || "#317b43",
    });
}
function darker(sourceColor) {
    return color(sourceColor).darken(0.0625).toHexString();
}
function lighter(sourceColor) {
    return color(sourceColor).lighten(0.0625).toHexString();
}
export const theme = stylesheet({
    reset: {
        backgroundColor: "var(--color-background)",
        color: "var(--color-foreground)",
    },
    moreContrast: {
        backgroundColor: "var(--color-background-more-contrast)",
        color: "var(--color-foreground-more-contrast)",
    },
    lessContrast: {
        backgroundColor: "var(--color-background-less-contrast)",
        color: "var(--color-foreground-less-contrast)",
    },
    backgroundError: {
        backgroundColor: "var(--color-error)"
    },
    backgroundWarning: {
        backgroundColor: "var(--color-warning)"
    },
    backgroundSuccess: {
        backgroundColor: "var(--color-success)"
    },
});
//# sourceMappingURL=theme.js.map